import {
  membershipStatusToolDef,
  type MembershipStatusToolDef,
} from '@form-factory/schema/contracts';

import { MembershipStatus } from './components/MembershipStatus';
import { createToolComponent } from '../../../toolRegistry';
import { ToolNoDataError } from '../components/ToolNoDataError';

export const MembershipStatusTool = createToolComponent(
  {
    schema: {
      content: membershipStatusToolDef,
    },
  },
  ({ toolCall, state, content }) => {
    // Don't render during streaming
    if (state === 'call' || state === 'call-partial') {
      return null;
    }

    // Get data - ToolProvider already unwrapped it
    const data = state === 'result' && content ? content : toolCall.args;

    // Return early if we don't have data
    if (!data) {
      return null;
    }

    const args = data as MembershipStatusToolDef;

    if (!args.content && (state === 'call-complete' || state === 'result')) {
      return <ToolNoDataError />;
    }

    return <MembershipStatus status={{ ...args, content: args.content }} />;
  },
);
